import { render, staticRenderFns } from "./limitCustomersAction.vue?vue&type=template&id=48b6d46e&scoped=true"
import script from "./limitCustomersAction.vue?vue&type=script&lang=js"
export * from "./limitCustomersAction.vue?vue&type=script&lang=js"
import style0 from "./limitCustomersAction.vue?vue&type=style&index=0&id=48b6d46e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b6d46e",
  null
  
)

export default component.exports